export let PusherEvent = /*#__PURE__*/function (PusherEvent) {
  PusherEvent["InvoiceEvent"] = "invoice-event";
  PusherEvent["MailboxUpdated"] = "mailbox-updated";
  PusherEvent["KYCStatusUpdated"] = "kyc-status-updated";
  PusherEvent["PaymentMethod"] = "payment-method";
  PusherEvent["VendorBankAccountConnected"] = "vendor-bank-account";
  return PusherEvent;
}({});

/** Pusher event for channel_name=<businessId>, eventName='invoice-event'. */

/** Pusher event for channel_name=<businessId>, eventName='payment-method'. */

/** Pusher event for channel_name=<businessId>, eventName='vendor-bank-account'. */

export let PaymentMethodEventType = /*#__PURE__*/function (PaymentMethodEventType) {
  PaymentMethodEventType["PaymentMethodAdded"] = "paymentMethodAdded";
  PaymentMethodEventType["PaymentMethodUpdated"] = "paymentMethodUpdated";
  PaymentMethodEventType["FailedToAddPaymentMethod"] = "failedToAddPaymentMethod";
  PaymentMethodEventType["VendorBankAccountConnected"] = "vendorBankAccountConnected";
  return PaymentMethodEventType;
}({});